import { z } from 'zod';
import { email } from './common';

export const Login = z.object({
  email,
  password: z.string().min(1, 'PASSWORD_REQUIRED'),
  source: z.string().optional(),
});

export const SSOLogin = z.object({
  email,
  invite: z.string().optional(),
});

export const googleLogin = z.object({
  code: z.string(),
});
